<template>
  <div id="app" class="flex flex-col w-full relative">
    <nav class="bg-red-600 w-full drop-shadow fixed ">
      <div class=" flex lg:flex-row flex-col  lg:items-center justify-between p-2 mx-auto max-w-screen-xl">
      <div class="flex items-center justify-between"><router-link to="/" ><div aria-label="Ves a la pàgina d'inici" class="flex items-center hover:bg-red-500 rounded-sm">
      <img src="./assets/Mosaic-Logo-SF.png" alt="Ves a la pàgina d'inici" class="md:w-16 w-12" >
      <h1 class="text-white font-bold text-xl m-3 mr-5 text-nowrap">Mosaic Casteller</h1>
      
      </div></router-link>
      <button aria-label="Desplegar Menú" @click="open=!open" class="lg:hidden text-3xl text-white justify-end px-4 py-2 hover:bg-red-500">
        <font-awesome-icon :icon="['fas', 'bars']" /> 
      </button></div>
      <Transition name="dropdown" appear>
      <div  v-if="open" class="lg:inline overflow-hidden">
        <ul class="flex lg:flex-row flex-col lg:items-center text-base gap-1 font-bold text-white mt-3 lg:mt-0">
        <router-link 
        v-for="(page,index) in pages" :key="index"  
        @click="hideOnClick()" :to="page.link" 
        class="group hover:bg-red-500 focus:bg-red-500 py-2 px-3 text-nowrap rounded-sm transition-all"
        active-class="group hover:text-white focus:text-white bg-white text-red-600 py-2 px-3 text-nowrap rounded-sm transition-all">
          <li clas="flex flex-row items-center">
            <span class="group-hover:underline group-focus:underline">{{page.name}}</span><span v-if="page.novetat" class="drop-shadow text-xs self-start bg-white rounded-sm px-1 ml-0.5 text-red-600">NOU</span></li>
          </router-link>

          
      <li @focusout="!$event.currentTarget.contains($event.relatedTarget) && (desplegaJocs = false)">
        <button @click="desplegaJocs = !desplegaJocs" 
        class="hover:bg-red-500 py-2 px-3 text-nowrap rounded-sm bg-red-600 text-white flex items-center">
          <span class="group-hover:underline">Jocs <font-awesome-icon :icon="['fas', 'chevron-down']"/></span><!--<span class="drop-shadow text-xs self-start bg-white rounded-sm px-1 ml-0.5 text-red-600">NOU</span>-->
        </button>
        <Transition name="dropdown" appear>
          <div v-if="desplegaJocs" class="overflow-hidden lg:absolute bg-white drop-shadow-lg text-red-600 rounded-sm flex flex-col p-1 h-fit w-full lg:w-fit gap-1">
            <router-link 
            @mousedown.prevent="desplegaJocs = !desplegaJocs, hideOnClick()"
            @keydown.enter="desplegaJocs = !desplegaJocs, hideOnClick()"
            to="/jocs/trobacolla" class="bg-white py-1 px-3 hover:bg-red-600 rounded-sm hover:text-white hover:underline text-left">TrobaColla</router-link>
            <router-link               
            @mousedown.prevent="desplegaJocs = !desplegaJocs, hideOnClick()"
            @keydown.enter="desplegaJocs = !desplegaJocs, hideOnClick()"
            to="/jocs/4colors" class="bg-white py-1 px-3 hover:bg-red-600 rounded-sm hover:text-white hover:underline text-left flex items-center">4Colors
            <span class="drop-shadow text-xs self-start bg-red-600 rounded-sm px-1 ml-0.5 text-white self-start">beta</span></router-link>
            <router-link               
            @mousedown.prevent="desplegaJocs = !desplegaJocs, hideOnClick()"
            @keydown.enter="desplegaJocs = !desplegaJocs, hideOnClick()"
            to="/jocs/picacamises" class="bg-white py-1 px-3 hover:bg-red-600 rounded-sm hover:text-white hover:underline text-left flex items-center">PicaCamises<span class="drop-shadow text-xs self-start bg-red-600 rounded-sm px-1 ml-0.5 text-white self-start">beta</span></router-link>

            <router-link 
            to="#" class="py-1 px-3 bg-gray-200 rounded-sm text-left text-gray-400">4Colles</router-link>
            <router-link 
            to="#" class="py-1 px-3 bg-gray-200 rounded-sm text-left text-gray-400">4Escuts</router-link>
          </div>
        </Transition>
      </li>
      <li @focusout="!$event.currentTarget.contains($event.relatedTarget) && (desplegaAbout = false)">
        <button @click="desplegaAbout = !desplegaAbout" 
        class="hover:bg-red-500 py-2 px-3 text-nowrap rounded-sm bg-red-600 text-white flex flex-row items-center">
          <span class="group-hover:underline">Sobre el Mosaic <font-awesome-icon :icon="['fas', 'chevron-down']"/></span><!--<span class="drop-shadow text-xs self-start bg-white rounded-sm px-1 ml-0.5 text-red-600">NOU</span>-->
        </button>
        <Transition name="dropdown" appear>
          <div v-if="desplegaAbout" class="overflow-hidden lg:absolute bg-white drop-shadow-lg text-red-600 rounded-sm flex flex-col p-1 h-fit w-full lg:w-fit">
            <router-link 
            @mousedown.prevent="desplegaAbout = !desplegaAbout, hideOnClick()"
            @keydown.enter="desplegaAbout = !desplegaAbout, hideOnClick()"
            to="/about" class="bg-white py-1 px-3 hover:bg-red-600 rounded-sm hover:text-white hover:underline text-left">Què és el Mosaic?</router-link>
             <router-link 
            @mousedown.prevent="desplegaAbout = !desplegaAbout, hideOnClick()"
            @keydown.enter="desplegaAbout = !desplegaAbout, hideOnClick()"
            to="/changelog" class="bg-white py-1 px-3 hover:bg-red-600 rounded-sm hover:text-white hover:underline text-left">Registre de Versions</router-link>
            <router-link               
            @mousedown.prevent="desplegaAbout = !desplegaAbout, hideOnClick()"
            @keydown.enter="desplegaAbout = !desplegaAbout, hideOnClick()"
            to="/informaciopendent" class="bg-white py-1 px-3 hover:bg-red-600 rounded-sm hover:text-white hover:underline text-left">Informació Pendent</router-link>
            <router-link 
            @mousedown.prevent="desplegaAbout = !desplegaAbout, hideOnClick()"
            @keydown.enter="desplegaAbout = !desplegaAbout, hideOnClick()"
            to="/webgrafia" class="bg-white py-1 px-3 hover:bg-red-600 rounded-sm hover:text-white hover:underline text-left">Webgrafia</router-link>
          </div>
        </Transition>
      </li>
    </ul>
</div>
  </Transition>
  </div>
    </nav>
    <main class="grow min-h-[50vh] md:mt-20 mt-16">
       <router-view/>
    </main>
    <footer class="bg-red-600 w-full">
      
      <div class="flex flex-col md:flex-row justify-center items-center md:items-center justify-between p-4 mx-auto max-w-screen-xl text-white text-center gap-8">
        
        
          <div class="flex-1 justify-center flex flex-col items-center">
            <div class="flex flex-col text-white text-left text-sm">
              <h3 class="">Origen de les dades:</h3>
              <ul class="ml-2 mb-1">
                <li><a class="hover:underline opacity-80 hover:opacity-100" href="https://ca.wikipedia.org/wiki/Llista_de_colles_castelleres" target="_blank" rel="noopener noreferrer">Llista de Colles Castelleres (Viquipèdia)</a></li>
          <li><a class="hover:underline opacity-80 hover:opacity-100" href="https://castellscat.cat/ca/les-colles-llistat" target="blank">Llistat de Colles Castelleres (CCCC)</a></li>
          <li><a class="hover:underline opacity-80 hover:opacity-100" href="https://sigac.cat" target="blank">SiGAC</a></li>
          <li><a class="hover:underline opacity-80 hover:opacity-100" href="https://castell.manies.cat" target="blank">castell.manies.cat</a></li>
          <li><a class="hover:underline opacity-80 hover:opacity-100" href="https://portalcasteller.cat" target="blank">Portal Casteller</a> </li>
          <li><a class="hover:underline opacity-80 hover:opacity-100" href="https://barometrecasteller.blogspot.com" target="blank">Baròmetre Casteller</a></li>
          </ul>
          <p>Més informació a: <router-link to="/about" class="hover:underline opacity-80 hover:opacity-100">Sobre el Mosaic</router-link>.</p>
        </div>
        </div>
          <div class="flex-1 justify-center flex flex-col items-center order-first md:order-none">
            
            <h3 class="leading-none">Mosaic Casteller<br> <span class="text-white/70 text-sm hover:underline"><router-link to="/changelog">Versió {{versio}}</router-link></span></h3>
            
            <img src="./assets/Mosaic-Logo-SF-Mini.png" alt="Logotip Mosaic" class="w-10 mt-1 mb-2" >
            <div class="text-2xl flex gap-2 justify-center">
            <a title="Ves al meu Instagram" aria-label="Ves al Instagram del Mosaic"   href="https://instagram.com/mosaic.casteller" target="blank" class="opacity-80 hover:opacity-100 "><font-awesome-icon :icon="['fab','instagram']"/></a>
            <a title="Ves al meu Twitter/X" aria-label="Ves al Twitter/X del Mosaic"   href="https://x.com/mosaiccasteller" target="blank" class="opacity-80 hover:opacity-100 "><font-awesome-icon :icon="['fab','x-twitter']"/></a>
          </div>
          <div class="gap-2 flex flex-col mt-2">
            
           </div>
          <div class="gap-2 flex flex-col mt-2">
          <p class="text-sm max-w-64">Si trobes informació incorrecte, desactualitzada o faltant, fes-la arribar a:</p>
          <a class="hover:underline opacity-80 hover:opacity-100" href="mailto:contacte@mosaiccasteller.cat" target="_blank">contacte@mosaiccasteller.cat</a>
          <p class="text-sm">Gràcies!</p>
        </div>
          </div>
        <!--<div class="hidden md:block md:flex-1"></div>-->
        <div class="flex-1 justify-center flex flex-col items-center">
          <h3 class="text-sm">Creat per:</h3>
         <a href="https://linktr.ee/eutatsu" class="mx-auto justify-center mt-2"><img :src=LogoEutatsu width="100%" class="w-12 opacity-80 hover:opacity-100" alt="Enllaços Eutatsu"></a>
          <router-link :to="{path:'/about',hash:'#yo'}" class="hover:underline"><p><strong>Eudald Cardozo i Vallhonrat</strong></p></router-link>
          <p class="opacity-80 text-sm" >@eutatsu</p>
          <div class="text-2xl flex gap-2 justify-center">
            <a title="Contacta'm per correu" aria-label="Contacta'm per correu" href="mailto:eudald.ca.va@gmail.com"  target="_blank" class="opacity-70 hover:opacity-100 "><font-awesome-icon alt="Correu" :icon="['fas','envelope']"/></a>
            <a title="Ves al meu Linktree" aria-label="Ves al meu Linktree" href="https://linktr.ee/eutatsu" target="blank" class="opacity-70 hover:opacity-100 "><font-awesome-icon alt="Correu" :icon="['fas','link']"/></a>
            <a title="Ves al meu Instagram" aria-label="Ves al meu Instagram"   href="https://instagram.com/eutatsu" target="blank" class="opacity-70 hover:opacity-100 "><font-awesome-icon :icon="['fab','instagram']"/></a>
            <a  title="Ves al meu Twitter/X" aria-label="Ves al meu Twitter/X"   href="https://x.com/eutatsu" target="blank" class="opacity-70 hover:opacity-100 "><font-awesome-icon :icon="['fab','x-twitter']"/></a>
          </div>
          <p class="text-sm max-w-64 mb-2">El Mosaic Casteller és un projecte independent sense un equip o entitat al darrere. Considera fer una petita donació o fer-te mecenes per mostrar el teu suport:</p>
          <a href="https://mosaic.aixeta.cat/ca" target="_blank">
  <img
    src="https://promo-assets.aixeta.cat/become-a-patron-ca-234x60.png"
    width="234"
    height="60">
</a>
          
        </div>
        <!--
        <div class="flex-1"><h3 class="text-sm mb-2">Origen de les dades:</h3>
          <ul class="text-sm flex flex-col justify-center items-center mx-auto gap-2">
          <a class="hover:underline hover:bg-red-500" href="https://ca.wikipedia.org/wiki/Llista_de_colles_castelleres" target="blank">ca.wikipedia.org</a>
          <a class="hover:underline hover:bg-red-500" href="https://castellscat.cat/ca/les-colles-llistat" target="blank">castellscat.cat</a>
          <a class="hover:underline hover:bg-red-500" href="https://sigac.cat/colles" target="blank">sigac.cat</a>
          <a class="hover:underline hover:bg-red-500" href="http://www.portalcasteller.cat/v2/colles/" target="blank">portalcasteller.cat</a>
          <a class="hover:underline hover:bg-red-500" href="https://castell.manies.cat" target="blank">castell.manies.cat</a>
          <p>Més informació a: <router-link class="hover:underline font-bold" to="/about">Sobre el mosaic</router-link></p>
        </ul>
      </div>-->
       <!-- <div class="col-span-1"><h3 class="text-base">Pàgines:</h3> <ul class="flex flex-col md:items-center text-sm text-white mt-3 md:mt-0">
          <router-link v-for="(page,index) in pages" :key="index"  @click="ObrirNav()" :to="page.link" class="group hover:bg-red-500" ><li class="py-1 px-3 "><button class="group-hover:underline ">{{page.name}}</button></li></router-link>
          
      </ul></div>-->
      </div>
      <h3 class="text-sm opacity-90 mt-4 w-full text-center text-white mb-4">© 2025 Mosaic Casteller. Tots els drets reservats. </h3>
    </footer>
    <PromptInstalla/>
  </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted, inject} from 'vue'
import LogoEutatsu from '@/assets/logo_eutatsu.png'
import PromptInstalla from '@/components/PromptInstalla.vue'

const versio=inject("version")

let open=ref(false)

function hideOnClick(){
  if (window.innerWidth <= 1024 ) open.value=false
  
}

function checkViewport() {
  if (window.innerWidth >= 1024) open.value=true
  else{
    open.value=false
  }
}

onMounted(() => {
  checkViewport()
  window.addEventListener('resize', checkViewport)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkViewport)
})

let desplegaJocs=ref(false)
let desplegaAbout=ref(false)

let pages=[
  { name:'Mosaic',link:'/',novetat:false},
  { name:'Colles',link:'/colles',novetat:false},
  { name:'Linia Temporal',link:'/liniatemporal',novetat:false},
  { name:'Mapa',link:'/mapa',novetat:false}]
/*let jocs=[
  { name:'Trobacolla',link:'/jocs/trobacolla'},
  { name:'PicaCamises',link:'#'}]
*/
</script>

<style>
#app {
  font-family: Aileron , Helvetica, Arial, sans-serif;

  min-height: 100vh;
  display:flex;
  grid-template-rows: auto 1fr auto;
}

nav{
  z-index: 9999;
}

input[type="range"]::-webkit-slider-thumb{
  background-color:#dd1725;
  border-style:none;
}

input[type="range"]::-moz-range-thumb{
  background-color:#dd1725;
  border-style:none;
}

.custom-control-input:checked ~ .custom-control-label::before{
    background-color:#dd1725;
    border-color:#dd1725
}

.tippy-box{
    background-color:rgba(0, 0, 0, 0.5);
    border-radius: 0px;
    
}
.tippy-content{
    padding: 0px;
}

.dropdown-enter-active,.dropdown-leave-active{
  transition: max-height 0.2s 
}

.dropdown-enter-from,.dropdown-leave-to{
  max-height: 0
}

.dropdown-enter-to,.dropdown-leave-from{
  max-height: 400px
}

</style>
